import React from 'react';
import '../../styles/TemplateList.css';

const TemplateList = ({ templates, selectedTemplate, onTemplateSelect }) => {
    return (
        <div className="template-list">
            {templates.map((template) => (
                <div
                    key={template.id}
                    className={`template-item ${selectedTemplate === template.id ? 'selected' : ''}`}
                    onClick={() => onTemplateSelect(template.id)}
                >
                    <img
                        src={template.previewUrl || 'https://via.placeholder.com/150'} // Placeholder if no preview
                        alt={template.name}
                        className="template-preview"
                    />
                    <span className="template-name">{template.name}</span>
                </div>
            ))}
        </div>
    );
};

export default TemplateList;
